module.exports = __webpack_public_path__ + "img/reju-bg.90c3c8f8.jpg";